import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { Input } from 'components/Input/Input'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Flex } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { OtherText, TitleText } from 'styling/Typography'
import { IAddOperationPlanTab, IOperationPlanState } from 'types/operationPlans.interface'

export const Identity = ({ setStep, setState, state }: IAddOperationPlanTab) => {

    const navigate = useNavigate()

    const handleNext = () => {
        if (!state.name) {
            toast.warn('Name is required');
            return
        }
        setStep(2)
    }

    const handleBack = () => navigate(-1)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setState((prev: IOperationPlanState) => ({ ...prev, [name]: value }))
    }


    return <>
        <Container>
            <ContainerHeader>
                <TitleText>What are we doing?</TitleText>
            </ContainerHeader>
            <ContainerContent>
                <Flex gap='1rem'>
                    <Flex column width='100%'>
                        <Input type='text' name='name' value={state.name} labelText='Name' onChange={handleChange} placeholder='Q1 Mill Throughput Push' required />
                        <OtherText grey>Give it a name your crew will recognise, e.g. North Pit Extraction</OtherText>
                    </Flex>
                    <Flex column width='100%'>
                        <Input type='text' name='code' value={state.code} labelText='Code' onChange={handleChange} placeholder='MTP-Q1-2026' />
                        <OtherText grey>Short code for reports (optional)</OtherText>
                    </Flex>
                </Flex>

            </ContainerContent>

        </Container>
        <Flex gap='1rem' mt='32' justend>
            <Button variant='secondary' onClick={handleBack}>Back</Button>
            <Button variant='primary' onClick={handleNext} >Next</Button>
        </Flex>
    </>
}